import React from 'react'

const SvgRoundLeft = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
        <path d="M12.266 5.455a5.284 5.284 0 00-3.761-1.558H2.612l1.994-1.993A.704.704 0 003.61.91L.38 4.14a.704.704 0 000 .995L3.52 8.273a.7.7 0 00.497.205.704.704 0 00.497-1.2L2.54 5.304h5.966c1.046 0 2.028.408 2.766 1.146a3.887 3.887 0 011.147 2.767v3.375a.703.703 0 101.406 0V9.217a5.276 5.276 0 00-1.558-3.762z" />
    </svg>
)

export default SvgRoundLeft
